/**
 * @file Settings.repository.ts
 * @module SettingsRepository
 * @description Reaktīvā stāvokļa krātuve kartes UI iestatījumiem (pārslēdzamas pogas).
 *              Izmanto @ngneat/elf, lai pārvaldītu, kuras kartes vadīklas ir redzamas:
 *              showPanBtn, showLegendBtn, showAttributionBtn.
 */

import { createStore, select, setProp, withProps } from "@ngneat/elf";

/** Map display settings state */
export interface SettingstoreProps {
	/** Whether the settings dialog is open */
	open?: boolean;
	/** Whether to show the legend panel */
	showLegendBtn?: boolean;
	/** Whether to show layer attribution/source info */
	showAttributionBtn?: boolean;
	/** Whether to show the drag-zoom (pan) control */
	showPanBtn?: boolean;
	/** Whether to enable base map transparency control */
	showBaseOpacity?: boolean;
	/** Base map opacity value (0 = fully transparent, 100 = fully opaque) */
	baseOpacity?: number;
	/** Whether to enable object/layer opacity control */
	showObjectOpacity?: boolean;
	/** Object/layer opacity value (0-100) */
	objectOpacity?: number;
	/** Whether to show the layer sets panel */
	showLayerSets?: boolean;
}

const storage = JSON.parse(localStorage.getItem("setting") as string);

const settingStore = createStore(
	{ name: "setting" },
	withProps<SettingstoreProps>({
		open: false,
		showLegendBtn: storage?.showLegendBtn ?? true,
		showAttributionBtn: storage?.showAttributionBtn ?? true,
		showPanBtn: storage?.showPanBtn ?? true,
		showBaseOpacity: storage?.showBaseOpacity ?? true,
		showObjectOpacity: storage?.showObjectOpacity ?? true,
		showLayerSets: storage?.showObjectOpacity ?? true,
	})
);

/** Returns an observable of the current settings state */
export function getSettingStore() {
	return settingStore.pipe(select((state) => state));
}

/** Updates one or more settings properties and persists to localStorage */
export function updateSettingStore(props: SettingstoreProps) {
	for (const key in props) {
		if (Object.prototype.hasOwnProperty.call(props, key)) {
			settingStore.update(setProp(key as keyof SettingstoreProps, (props as any)[key]));
		}
	}

	localStorage.setItem("setting", JSON.stringify(settingStore.getValue()));
}
